// extracted by mini-css-extract-plugin
export default {"Container":"About_Container__a+FjZ","LogoContainer":"About_LogoContainer__mLmXs","Title":"About_Title__ZQ-kt"};